import { Grid } from '@mui/joy'
import { useTranslation } from 'react-i18next'
import { NumericInput, Switch } from '~/shared/ui/Form'
import { Container, ContainerTitle } from '~/shared/ui/Layout'

type StateProps = {
  loading: boolean
}

export function State({ loading }: StateProps) {
  const { t } = useTranslation()

  return (
    <Container>
      <ContainerTitle>{t('form.state')}</ContainerTitle>
      <Grid container spacing={5}>
        <Grid xs={6} sx={{ paddingBottom: 0 }}>
          <NumericInput
            label='form.mileage'
            name='mileage'
            numericProps={{
              thousandSeparator: ' ',
              suffix: ` ${t('km')}`,
            }}
            readOnly
            skeletonShow={loading}
          />
        </Grid>
        <Grid xs={6} />

        <Grid xs={6}>
          <Switch
            labelI18n='form.car is clean'
            name='isExteriorClean'
            readOnly
            skeletonShow={loading}
          />
        </Grid>
        <Grid xs={6}>
          <Switch
            labelI18n='form.car is refueled'
            name='isCarRefueled'
            readOnly
            skeletonShow={loading}
          />
        </Grid>
        <Grid xs={6}>
          <Switch
            labelI18n='form.tobacco smell'
            name='hasTobaccoSmell'
            readOnly
            skeletonShow={loading}
          />
        </Grid>
        <Grid xs={6}>
          <Switch
            labelI18n='form.dirty interior'
            name='isInteriorDirty'
            readOnly
            skeletonShow={loading}
          />
        </Grid>
        <Grid xs={6}>
          <Switch
            labelI18n='form.dry cleaning needed'
            name='isDryCleaningNeed'
            readOnly
            skeletonShow={loading}
          />
        </Grid>
      </Grid>
    </Container>
  )
}
